import { HandelApi } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const RecordMethods = async (
    position: any,
    typeRecord: any,
    typeScan: string,
    scanData: any,
    setDisplayBtn: (bol: boolean) => void,
    setVisible: (bol: boolean) => void,
    setDisplayScanner: (bol: boolean) => void,
    displayBtn: boolean,
) => {
    try {
        if (typeScan == 'scan' && (!scanData || scanData == "" || scanData == null)) return
        if (typeScan == 'link' && (!sessionStorage.getItem('qr') || sessionStorage.getItem('qr') == null)) { return toast('شما با لینک اختصاصی وارد نشده اید', { type: "error" }) }
        if (displayBtn == true) return
        if (position == null) return toast('دسترسی به موقعیت امکان پذیر نیست', { type: "error" })

        setDisplayBtn(true)
        const postData: any = {
            lat: position[0],
            lng: position[1],
            roll_call_type: typeRecord
        }
        typeScan == 'scan' ? postData['QRcode'] = scanData : postData['slug'] = sessionStorage.getItem('qr')
        let res = await HandelApi(postData, typeScan)
        setDisplayBtn(false)
        if (res.data.status == "OK") {
            setVisible(false)
            setDisplayScanner(false)
            toast(res.data.message, { type: "success" })
        }
        else {
            toast(res.data.message, { type: "error" })
            setDisplayScanner(false)
            setVisible(false)
        }
    }
    catch (err: any) {
        setDisplayBtn(false)
        setDisplayScanner(false)
        setVisible(false)
        toast('شما اجازه دسترسی به این قسمت را ندارید', { type: "error" })
    }
}